// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"164b22a5","288":"fb0f99ea","293":"ee15fbe7","355":"5c1525a9","466":"ad4a072d","774":"ac8b9265","799":"5256b9a7","964":"ad3e798e"}[chunkId] + ".chunk.js";
};